/* Generated from Java with JSweet 2.3.5 - http://www.jsweet.org */
import { Oas20Definitions } from '../models/Oas20Definitions';
import { Oas20Headers } from '../models/Oas20Headers';
import { Oas20Items } from '../models/Oas20Items';
import { Oas20ParameterDefinitions } from '../models/Oas20ParameterDefinitions';
import { Oas20ResponseDefinitions } from '../models/Oas20ResponseDefinitions';
import { Oas20Scopes } from '../models/Oas20Scopes';
import { Oas20SecurityDefinitions } from '../models/Oas20SecurityDefinitions';
import { OasAllNodeVisitor } from '../../visitors/OasAllNodeVisitor';
import { IOas20Visitor } from './IOas20Visitor';

/**
 * Constructor.
 * @class
 * @extends OasAllNodeVisitor
 * @author eric.wittmann@gmail.com
 */
export class Oas20AllNodeVisitor extends OasAllNodeVisitor implements IOas20Visitor {
    public constructor() {
        super();
    }

    /**
     * @see io.apicurio.datamodels.openapi.v2.visitors.IOas20Visitor#visitItems(io.apicurio.datamodels.openapi.v2.models.Oas20Items)
     * @param {Oas20Items} node
     */
    public visitItems(node : Oas20Items) {
        this.visitNode(node);
    }

    /**
     * @see io.apicurio.datamodels.openapi.v2.visitors.IOas20Visitor#visitScopes(io.apicurio.datamodels.openapi.v2.models.Oas20Scopes)
     * @param {Oas20Scopes} node
     */
    public visitScopes(node : Oas20Scopes) {
        this.visitNode(node);
    }

    /**
     * @see io.apicurio.datamodels.openapi.v2.visitors.IOas20Visitor#visitSecurityDefinitions(io.apicurio.datamodels.openapi.v2.models.Oas20SecurityDefinitions)
     * @param {Oas20SecurityDefinitions} node
     */
    public visitSecurityDefinitions(node : Oas20SecurityDefinitions) {
        this.visitNode(node);
    }

    /**
     * @see io.apicurio.datamodels.openapi.v2.visitors.IOas20Visitor#visitDefinitions(io.apicurio.datamodels.openapi.v2.models.Oas20Definitions)
     * @param {Oas20Definitions} node
     */
    public visitDefinitions(node : Oas20Definitions) {
        this.visitNode(node);
    }

    /**
     * @see io.apicurio.datamodels.openapi.v2.visitors.IOas20Visitor#visitParameterDefinitions(io.apicurio.datamodels.openapi.v2.models.Oas20ParameterDefinitions)
     * @param {Oas20ParameterDefinitions} node
     */
    public visitParameterDefinitions(node : Oas20ParameterDefinitions) {
        this.visitNode(node);
    }

    /**
     * @see io.apicurio.datamodels.openapi.v2.visitors.IOas20Visitor#visitHeaders(io.apicurio.datamodels.openapi.v2.models.Oas20Headers)
     * @param {Oas20Headers} node
     */
    public visitHeaders(node : Oas20Headers) {
        this.visitNode(node);
    }

    /**
     * @see io.apicurio.datamodels.openapi.v2.visitors.IOas20Visitor#visitResponseDefinitions(io.apicurio.datamodels.openapi.v2.models.Oas20ResponseDefinitions)
     * @param {Oas20ResponseDefinitions} node
     */
    public visitResponseDefinitions(node : Oas20ResponseDefinitions) {
        this.visitNode(node);
    }
}
Oas20AllNodeVisitor["__class"] = "io.apicurio.datamodels.openapi.v2.visitors.Oas20AllNodeVisitor";
Oas20AllNodeVisitor["__interfaces"] = ["io.apicurio.datamodels.core.visitors.IVisitor","io.apicurio.datamodels.openapi.v2.visitors.IOas20Visitor","io.apicurio.datamodels.openapi.visitors.IOasVisitor"];




